import React from "react";
import { Container } from 'react-bootstrap';

export default function Items() {
  return <Container>Items</Container>;
}
